import { Avatar, Box, Typography } from "@mui/material";
import React from "react";
import { Rating } from "react-simple-star-rating";
import Constant from "src/utils/Constant";
import Helper from "src/utils/Helper";

const Testimonies = ({ testimonies, customStyle = {} }) => {
  if (!customStyle?.isTestimonialsEnabled) return null;

  if (testimonies.length === 0) return null; // force to hide no testimonials

  return (
    <Box>
      <Box sx={{ mt: "24px" }}>
        <Box>
          <Typography
            sx={{
              fontFamily: `var(--font-${customStyle?.headingFont})`,
              fontSize: "20px",
              color: customStyle?.textColor ?? "#19181B",
            }}
          >
            Testimonials
          </Typography>
        </Box>
      </Box>

      {testimonies.length === 0 ? (
        <Box
          sx={{
            mt: "24px",
            p: "24px",
            border: "1px solid #DFE2E6",
            backgroundColor: "#F2F2F2",
            borderRadius: "12px",
          }}
        >
          <Typography
            sx={{
              color: customStyle?.secondaryTextColor ?? "#878787",
              fontFamily: `var(--font-${customStyle?.bodyFont})`,
              textAlign: "center",
            }}
          >
            No testimonials available for this package.
          </Typography>
        </Box>
      ) : (
        <Box>
          <Box sx={{ mt: "8px" }}>
            {testimonies.map((data, key) => {
              return (
                <Box
                  key={key}
                  sx={{
                    borderRadius: "12px",
                    border: "1px solid #DFE2E6",
                    ...(customStyle?.borderColor && {
                      border: `1px solid ${customStyle?.borderColor}`,
                    }),
                    backgroundColor: "#FFFFFF",
                    p: "24px",
                    my: "16px",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      gap: "16px",
                      alignItems: "center",
                    }}
                  >
                    {data.avatar && (
                      <Box>
                        <Avatar
                          sx={{
                            width: "40px",
                            height: "40px",
                          }}
                          src={Constant.getFileInStorage(
                            "testimonials",
                            data.avatar
                          )}
                        />
                      </Box>
                    )}

                    <Box>
                      <Typography
                        sx={{
                          fontSize: "16px",
                          fontWeight: 500,
                          fontFamily: `var(--font-${customStyle?.bodyFont})`,
                          color: customStyle?.textColor ?? "#19181B",
                        }}
                      >
                        {data.firstname} {data.lastname}
                      </Typography>

                      <Box sx={{ display: "flex", gap: "8px" }}>
                        <Typography
                          sx={{
                            fontSize: "14px",
                            fontWeight: 500,
                            display: "-webkit-box",
                            WebkitLineClamp: 1,
                            WebkitBoxOrient: "vertical",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            fontFamily: `var(--font-${customStyle?.bodyFont})`,
                            color: customStyle?.secondaryTextColor ?? "#878787",
                          }}
                        >
                          {data.title}
                          {data.company && <span> &bull; {data.company}</span>}
                        </Typography>
                      </Box>

                      {data?.link && (
                        <Typography
                          sx={{
                            color:
                              customStyle?.accentColor ?? "var(--color-orange)",
                            fontFamily: `var(--font-${customStyle?.bodyFont})`,
                            fontSize: "14px",
                            fontWeight: 500,
                            textDecoration: "underline",
                            cursor: "pointer",
                            mt: "4px",
                          }}
                          onClick={() => {
                            let url = Helper.formatDomain(data.link);

                            window.open(url, "_blank");
                          }}
                        >
                          View website
                        </Typography>
                      )}
                    </Box>
                  </Box>

                  {Number(data.rating) > 0 && (
                    <Box sx={{ mt: "16px" }}>
                      <Rating
                        initialValue={data.rating}
                        size={25}
                        fillColor="#FFD700"
                        emptyColor="#e0e0e0"
                        readonly={true}
                        allowFraction={false}
                      />
                    </Box>
                  )}

                  <Box sx={{ mt: "16px" }}>
                    <Typography
                      sx={{
                        fontSize: "16px",
                        fontWeight: 400,
                        fontStyle: "italic",
                        lineHeight: "24px",
                        "&::before": {
                          content: '"\\201C"',
                          fontSize: "40px",
                        },
                        fontFamily: `var(--font-${customStyle?.bodyFont})`,
                        color: customStyle?.textColor ?? "#19181B",
                      }}
                    >
                      {data.testimony}
                    </Typography>
                  </Box>
                </Box>
              );
            })}
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default Testimonies;
